import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SystemicCaseResponse, SystemicCaseVO } from 'src/app/services/gen';
import { SystemicResourceService } from 'src/app/services/gen/api/systemicResource.service';

@Injectable({
	providedIn: 'root',
})
export class SystemicService {
	onSave: Subject<any> = new Subject();
	onExport: Subject<any> = new Subject();
	constructor(private systemicServ: SystemicResourceService) {}

	addSystemicCaseInformation(payload: SystemicCaseVO): Observable<SystemicCaseResponse> {
		return this.systemicServ.addSystemicCaseInformation(payload);
	}
}
